'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

const MobileNavbar = () => {
    const pathname = usePathname();

    const navItems = [
        { label: 'Home', href: '/homepage', icon: 'HomeIcon' },
        { label: 'Services', href: '/services', icon: 'Squares2X2Icon' },
        { label: 'About', href: '/about', icon: 'UserGroupIcon' },
        { label: 'Brand Lab', href: '/brand-visibility-lab', icon: 'ChartBarIcon' },
        { label: 'Contact', href: '/contact', icon: 'EnvelopeIcon' },
    ];

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-[100] bg-white/90 backdrop-blur-xl border-t border-slate-200 pb-safe pt-2 px-4 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]">
            <ul className="flex justify-between items-center max-w-md mx-auto">
                {navItems.map((item) => {
                    const isActive = pathname === item.href ||
                        (item.href === '/homepage' && (pathname === '/' || pathname.startsWith('/homepage'))) ||
                        (item.href !== '/homepage' && pathname.startsWith(item.href));

                    return (
                        <li key={item.href} className="flex-1">
                            <Link
                                href={item.href}
                                className={`
                                    flex flex-col items-center justify-center py-2 relative group
                                    transition-colors duration-200
                                    ${isActive ? 'text-indigo-600' : 'text-slate-400 hover:text-slate-600'}
                                `}
                            >
                                {/* Active Indicator (Top Line) */}
                                {isActive && (
                                    <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-8 h-1 bg-indigo-600 rounded-b-full shadow-sm shadow-indigo-200" />
                                )}

                                <div className={`
                                    mb-1 transition-transform duration-200
                                    ${isActive ? '-translate-y-0.5 scale-110' : 'group-active:scale-90'}
                                `}>
                                    <Icon name={item.icon} className="w-6 h-6" />
                                </div>

                                <span className={`
                                    text-[10px] font-medium tracking-wide
                                    ${isActive ? 'opacity-100 font-bold' : 'opacity-80'}
                                `}>
                                    {item.label}
                                </span>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default MobileNavbar;
